import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Snackbar.module.css";
import { cx } from "../cx";
import { IconCheckmarkLine } from "../icons/Icon";

export type SnackbarProps = HTMLAttributes<HTMLDivElement> & {
  message: ReactNode;
  /** positive = 완료 알림(체크 아이콘, 시안 595:6547). neutral(기본) = 아이콘 없음 */
  tone?: "neutral" | "positive";
  /** 아이콘 직접 지정. 생략하면 tone 기본값, null 이면 숨김 */
  icon?: ReactNode | null;
  action?: { label: string; onClick: () => void };
};

/** SEED Snackbar (Figma 79:1957). 358×48, 하단 고정, 3초 후 사라짐(제어는 호스트). */
export function Snackbar({ message, tone = "neutral", icon, action, className, ...rest }: SnackbarProps) {
  const shown = icon === undefined ? (tone === "positive" ? <IconCheckmarkLine size={18} /> : null) : icon;
  return (
    <div role="status" className={cx(styles.root, className)} {...rest}>
      {shown !== null && <span className={styles.icon}>{shown}</span>}
      <span className={styles.message}>{message}</span>
      {action && (
        <button type="button" className={styles.action} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
